<template>
  <div class="metas" :class="{ 'metas--minimal': minimal }">
    <div class="meta">
      <div class="meta__icon">
        <svgicon icon="time" />
      </div>
      <div class="meta__content">
        <div v-if="showTotal || minimal" class="meta__label">
          <span v-if="!minimal">En tout: </span
          >{{ this.duration(this.totalDuration) }}
        </div>
        <Fragment v-if="!minimal">
          <div v-if="this.recipe.preparation_time" class="meta__label">
            Préparation: {{ this.duration(this.recipe.preparation_time) }}
          </div>
          <div v-if="this.recipe.cooking_time" class="meta__label">
            Cuisson: {{ this.duration(this.recipe.cooking_time) }}
          </div>
          <div v-if="this.recipe.sleeping_time" class="meta__label">
            Repos: {{ this.duration(this.recipe.sleeping_time) }}
          </div>
        </Fragment>
      </div>
    </div>
    <div class="meta">
      <div class="meta__icon">
        <svgicon :icon="difficultyIcon" />
      </div>
      <div class="meta__content">
        <div class="meta__label">{{ difficultyLabel }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Fragment } from "vue-fragment";

export default {
  name: "RecipeMetas",
  components: { Fragment },
  props: {
    recipe: { type: Object, required: true },
    minimal: { type: Boolean, default: false },
  },
  data() {
    return {
      metas: false,
    };
  },
  computed: {
    showTotal: function() {
      return this.recipe.cooking_time || this.recipe.sleeping_time;
    },
    totalDuration: function() {
      let duration = 0;
      if (this.recipe.preparation_time) {
        duration += this.recipe.preparation_time;
      }
      if (this.recipe.cooking_time) {
        duration += this.recipe.cooking_time;
      }
      if (this.recipe.sleeping_time) {
        duration += this.recipe.sleeping_time;
      }
      return duration;
    },
    difficultyIcon: function() {
      return (
        "signal-alt-" +
        (this.recipe.difficulty == 0 ? 1 : this.recipe.difficulty)
      );
    },
    difficultyLabel(difficulty) {
      const difficulties = [
        "Très facile",
        "Facile",
        "Moyen",
        "Difficile",
        "Très difficile",
      ];
      if (difficulties.length >= this.recipe.difficulty) {
        return difficulties[this.recipe.difficulty];
      } else {
        return false;
      }
    },
  },
  created() {},
  methods: {
    duration(duration) {
      return this.$duration(duration);
    },
  },
};
</script>
<style lang="scss" scoped>
.metas {
  &--minimal {
    display: flex;
    justify-content: center;
    .meta + .meta {
      margin-left: 10px;
    }
  }
}
.meta {
  display: flex;
  align-items: flex-start;
  margin-top: 5px;
  @include breakpoint(sm-max) {
    font-size: 12px;
  }
  &__icon {
    width: 20px;
    display: flex;
    align-items: flex-end;
    height: 1.2em;
  }
  svg {
    width: 1em;
    height: 1em;
  }
}
</style>
